import React from 'react';
import Sidebar from './Sidebar';
import Header from './Header';

const Layout = ({ user, onLogout, children }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar user={user} />
      <Header user={user} onLogout={onLogout} />
      <main className="ml-64 pt-20 p-8">
        {children}
      </main>
    </div>
  );
};

export default Layout;
